/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GUI   from 'services/gui';
import { t } from 'g3w-i18n';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'projects-menu',

  data() {
    return {
      state:   null,
      loading: false
    }
  },

  methods: {

    trigger(item) {
      if (item.cbk)        this._initCallback(item);
      else if (item.href)  window.open(item.href, '_blank');
      else if (item.route) GUI.goto(item.route);
      else                 console.log("No action for "+item.title);
    },

    /**
     * @since 3.8.0 
     */
    _initCallback(item) {
      this._toggleModal(true);
      item.cbk
        .call(item, { gid: item.gid })
        .then(promise => { // changeProject is a setter so it returns a promise
          promise
            .then(project => { if (project) document.title = project.state.html_page_title })
            .fail(() => { GUI.notify.error("<h4>" + t("error_map_loading") + "</h4>" + "<h5>"+ t("check_internet_connection_or_server_admin") + "</h5>"); })
            .always(() => { this._toggleModal(false); })
        });
    },

    /**
     * @since 3.8.0 
     */
    _toggleModal(state) {
      GUI.showFullModal({ show: state });
      GUI.setLoadingContent(state);
    },

    /**
     * @TODO extract as utility function (almost the same as `components/ChangeManpMenu::_setSrc(src)`) 
     */
    logoSrc(src) {
      let imageSrc;
      const host = this.$options.host || '';
      const has_media = src && (src.includes(window.initConfig.mediaurl));
      const not_static = src && (!src.includes('static') && !src.includes('media'))

      if (!src) {
        imageSrc = '/static/client/images/FakeProjectThumb.png';
      } else if (has_media) {
        imageSrc = src;
      } else if (not_static) {
        imageSrc = `${window.initConfig.mediaurl}${src}`;
      } else {
        imageSrc = '/static/client/images/FakeProjectThumb.png';
      }
  
      return `${host}${imageSrc}`;
    },

  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"menu-projects"}},[_c('div',{staticClass:"row row-equal"},[_vm._l((_vm.state.menuitems),function(menuitem){return _c('div',{key:menuitem.title,staticClass:"col-sm-4 project-menu",on:{"click":function($event){return _vm.trigger(menuitem)}}},[_c('div',{staticClass:"project-menu-item-image"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.logoSrc(menuitem.thumbnail)}})]),_vm._v(" "),_c('div',{staticClass:"project-menu-item-content"},[_c('div',{staticClass:"project-menu-item-text"},[_c('h4',{staticClass:"project-menu-item-title"},[_vm._v(_vm._s(menuitem.title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(menuitem.description)}})])])])}),_vm._v(" "),(!_vm.state.menuitems.length)?_c('div',{staticStyle:{"margin-left":"15px"}},[_c('h2',{directives:[{name:"t",rawName:"v-t",value:('no_other_projects'),expression:"'no_other_projects'"}]})]):_vm._e()],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3e1b9d58_0", { source: ".project-menu[data-v-3e1b9d58]{cursor:pointer;margin-bottom:20px;margin-top:20px}.project-menu-item-image[data-v-3e1b9d58]{position:relative;overflow:hidden;padding-bottom:50%}.project-menu-item-image img[data-v-3e1b9d58]{position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}.project-menu-item-content[data-v-3e1b9d58]{padding:15px;background:rgba(255,255,255,.3)}.project-menu-item-text[data-v-3e1b9d58]{position:relative;overflow:hidden;height:100%;text-align:justify}.project-menu-item-title[data-v-3e1b9d58]{text-align:center;font-weight:700;background:rgba(255,255,255,.5);padding:5px}#menu-projects[data-v-3e1b9d58]{width:100%;overflow-y:auto}#menu-projects .row-equal[data-v-3e1b9d58]{display:flex;flex-wrap:wrap}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-3e1b9d58"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ProjectsMenu.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__